export const isNotEmptyStringUndefinedOrNull = (value: any) => value !== null && value !== undefined && value !== ''
